/* eslint-disable no-param-reassign,no-shadow */
import { Store } from '@wonderlandlabs/looking-glass-engine';
import _ from 'lodash';
import React from 'react';
import { message } from 'antd';
import Button from '../../views/StyledButton';
import QueryModel from '../../store/models/Category/QueryModel';
import {
  categoryFetchQuery, categoryAddRecord, categoryFetchRecord, Category,
} from '../../store/models/Category';

import {
  eventToNumber, eventToBoolean, eventToString,
  eventToObject,
}
  from '../../utils/eventExtraction';
import DateFormatter from '../../utils/DateFormatter';
import percent from '../../utils/percent';

const TPART_RE = /(.*)\."(.*)"/;
const AS_RE = / AS (.*)$/i;

function trimTitleInner(t) {
  if (AS_RE.test(t)) {
    console.log('title found AC:', t);
    return _.trim(AS_RE.exec(t)[1], ' "');
  }
  if (!(t && _.isString(t))) {
    return '';
  }

  if (TPART_RE.test(t)) {
    return TPART_RE.exec(t)[2];
  }
  return t;
}

function trimTitle(t) {
  return <span title={t}>{trimTitleInner(t)}</span>;
}

const _lastOtherFields = [];
const _lastCache = '--starter--';
const _baseMedCols = false;

export default function queryMediaStore({
  query, token, activateObjDialog, showMedia,
}) {
  console.log('making queryMediaStore with ', query, 'token', token);


  const CUSTOM_PROPS = {
    dateCreated: { align: 'center', width: 200, className: 'no-wrap' },
    dateFinished: { align: 'center', width: 200, className: 'no-wrap' },
    length: { align: 'right' },
    'hits()': { align: 'right', width: 50 },
    totalSilenceRatio: { title: '%silence', width: 60 },
    mediaId: { width: 180, className: 'no-wrap' },
  };

  const FIELD_RENDERERS = {
    mediaId(id) {
      /* const parts = /^(.{4}).*(.{4})$/.exec(id);
      if (parts) {
        return <span style={({ fontFamily: 'Monaco, Courier, monospace' })} title={id}>{parts[1]} ... {parts[2]}</span>;
      } */
      return id;
    },
    metadata(data) {
      try {
        if (_.isString(data)) data = JSON.parse(data);
      } catch (err) {
        return ' ';
      }
      return (
        <Button size="small" onClick={() => activateObjDialog('Metadata', data)}>
          Metadata
        </Button>
      );
    },
    speakerWordCount(swc) {
      if (!swc) {
        return '';
      }
      let out = '';
      const keys = Object.keys(swc);
      if (keys.length === 1 && keys[0] === 'Unknown') {
        return swc.Unknown;
      }
      keys.forEach((key) => {
        out += `${key}: ${swc[key]},`;
      });
      return out;
    },
    'hits()': function (data) {
      try {
        const d = JSON.parse(data);
        if (d && Array.isArray(d)) {
          return (
            <Button size="small" onClick={() => activateObjDialog('hits()', { hits: d })}>
              {d.length}
            </Button>
          );
        }
        return data ? 1 : 0;
      } catch (err) {
        return ' ';
      }
    },
    length(value) {
      const l = value;
      if (_.isString(value)) {
        value = parseInt(value, 10);
      }
      if (!_.isNumber(value)) {
        return ' ';
      }
      return (
        <span title={`${l} ms`}>
          {Math.round(value / (60 * 1000), 0)}
          {' '}
min
        </span>
      );
    },
    categories(cats) {
      if (!(cats && _.isObject(cats))) {
        return 'null';
      }
      return _(Object.keys(cats))
        .map((category) => {
          if (cats[category]) {
            return category;
          }
          return false;
        })
        .compact()
        .map((term) => ((term.length) > 20 ? `${term.substr(0, 10)}...` : term))
        .sortBy(_.identity)
        .value()
        .join(', ');
    },
    dateCreated: DateFormatter.formatUtcShort,
    dateFinished: DateFormatter.formatUtcShort,
    totalSilenceRatio: percent,
  };


  const mediaStore = new Store({
    actions: {
      async executeQuery(store) {
        const { actions, state } = store;
        const { token, queryModel } = state;
        if (state.mediaLoading) {
          console.log('executeQuery: attempt to load a media when loading');
          return;
        }

        if (!token) {
          actions.setMediaLoadError(new Error('attempt to get categories without token'));
          console.log('no token');
          return;
        }
        actions.setMediaLoading(true);
        actions.setMediaLoaded(false);
        actions.setMediaLoadError(false);

        let query;
        try {
          query = queryModel.composed();
        } catch (err) {
          console.log('error composing query:', err);
        }

        try {
          const media = await categoryFetchQuery(query, token);
          console.log('media got with ', query, media);
          const rows = _.get(media, 'rows', []);
          const totalResults = _.get(media, 'totalResults', rows.length);
          console.log('retrieved:', rows, 'TR:', totalResults);
          actions.setMedia(rows);
          actions.setTotalResults(totalResults);
          actions.setMediaLoading(false);
          actions.setMediaLoaded(true);
        } catch (err) {
          console.log('media load error:', err);
          actions.setMedia([]);
          actions.setMediaLoading(false);
          actions.setMediaLoadError(err);
        }
        actions.syncPageEnds();
      },
      prevPage({ actions, state }) {
        actions.pageQuery(-1);
      },
      nextPage({ state, actions }) {
        actions.pageQuery(1);
      },
      syncPageEnds(store) {
        try {
          const {
            page, media, queryModel, totalResults,
          } = store.state;
          const { offset } = queryModel;
          const mediaLength = media.length;
          console.log('setting atEnd based on offset', offset, 'ml:', mediaLength, 'and totalResults: ', totalResults);
          store.actions.setAtStart(page < 1);

          store.actions.setAtEnd(totalResults <= (offset + mediaLength));
        } catch (err) {
          console.log('error in syncPageEnds: ', err);
        }
      },
      updateMedCols(store) {
        const fields = [
          {
            title: 'Play',
            key: 'play',
            dataIndex: 'mediaId',
            width: 80,
            render: (mid, row) => (!mid ? '---' : (
              <Button
                type="default"
                size="small"
                icon="caret-right"
                onClick={() => {
                  console.log('passing hits from ', row);
                  showMedia(mid, _.get(row, 'hits()', ''));
                }}
                title={`play ${mid}`}
              />
            )),
          },
        ];

        let otherFields = _.get(store, 'state.queryModel.select', '*');
        if (!otherFields || /\*/.test(otherFields)) {
          otherFields = ['mediaId', 'hits()', 'dateCreated', 'status', 'length', 'totalSilenceRatio'];
        } else {
          otherFields = _(otherFields)
            .split(',')
            .filter((a) => a && _.isString(a) && (a !== '*'))
            .map(_.trim)
            .value();
        }

        otherFields.forEach((field) => {
          let fieldKey = field;

          if (AS_RE.test(field)) {
            fieldKey = _.trim(AS_RE.exec(field)[1], ' "');
          }

          if (TPART_RE.test(field)) {
            const [__, part1, part2] = TPART_RE.exec(field);
            fieldKey = `${part1}:${part2}`;
          }

          const definition = {
            key: field,
            dataIndex: fieldKey,
            title: trimTitle(field),
            render: (...args) => {
              if (FIELD_RENDERERS[fieldKey]) {
                return FIELD_RENDERERS[fieldKey](...args);
              }

              let out = args[0];
              if (out === null || typeof out === 'undefined') {
                out = '(null)';
              } else if (typeof out === 'object') {
                try {
                  out = JSON.stringify(out);
                } catch (err) {
                  out = '--object--';
                }
              }
              return out;
            },
          };
          if (CUSTOM_PROPS[fieldKey]) {
            Object.assign(definition, CUSTOM_PROPS[fieldKey]);
          }
          fields.push(definition);
        });

        store.actions.setMedCols(fields);
      },
      async pageQuery(store, direction) {
        const { queryModel, page } = store.state;
        const newPage = Math.max(0, page + _.clamp(Math.round(direction), -1, 1));
        store.actions.setPage(newPage);
        queryModel.offset = queryModel.limit * store.state.page;
        store.actions.recomposeQuery();
        await store.actions.executeQuery();
      },

      recomposeQuery(store) {
        const { actions, state } = store;
        const model = state.queryModel;
        try {
          model.compose();
        } catch (err) {
          console.log('composing error', err);
          return;
        }
        actions.setQueryModel(model.clone());
        actions.updateMedCols();
      },

      chooseQuery(state, query) {
        state.actions.setQuery(query);
        state.actions.reflectQueryState();
      },

      reflectQueryState({ state, actions }) {
        const { query, queryModel } = state;
        const queryNewModel = new QueryModel(query);
        queryNewModel.offset = queryModel.offset;
        queryNewModel.compose();
        if (!queryNewModel.equalTo(queryModel)) {
          actions.setQuerySynced(false);
        } else {
          actions.setQuerySynced(true);
        }
      },

      updateQuery(store, query) {
        const { actions } = store;
        if (query) {
          try {
            const model = new QueryModel(query);
            actions.setQueryModel(model);
            actions.setPage(0);
            actions.syncPageEnds();
            actions.chooseQuery(query);
            actions.setRanOnce(true);
          } catch (err) {
            console.log('digest error');
          }
        }
        actions.updateMedCols();
        actions.executeQuery();
      },
    },
  })
    .addProp('token', {
      start: token,
      type: 'string',
    })
    .addProp('mediaLoaded', {
      type: 'boolean',
      start: false,
    })
    .addProp('mediaLoading', {
      type: 'boolean',
      start: false,
    })
    .addProp('querySynced', {
      type: 'boolean',
      start: false,
    })
    .addProp('ranOnce', false, 'boolean')
    .addProp('mediaLoadError', {
      start: false,
    })
    .addProp('atEnd', true, 'boolean')
    .addProp('atStart', true, 'boolean')
    .addProp('page', {
      start: 0,
      type: 'integer',
    })
    .addProp('queryModel', {
      start: new QueryModel(query),
      type: 'object',
    })
    .addProp('totalResults', 0, 'integer')
    .addProp('medCols', {
      start: [],
      type: 'array',
    })
    .addProp('media', {
      start: [],
      type: 'array',
    })
    .addProp('query', query, 'string'); // the query that the tab provides

  // why the default setting doesn't work is not clear
  mediaStore.actions.setToken(token);
  mediaStore.actions.chooseQuery(query);
  mediaStore.actions.updateMedCols();
  console.log('mediaStore: ', mediaStore.state);
  return mediaStore;
}
